class ManagerDataService {
  constructor() {
  }

  setManager(manager) {
    this._manager = manager;
  }

  getManager() {
    return this._manager;
  }

  clean() {
    this._manager = undefined;
  }

  isEmpty() {
    return this._manager === undefined;
  }
}

export default ManagerDataService;



// WEBPACK FOOTER //
// ./client/app/common/services/managerData.service.js